{
  "GenericAdminList_Footer_Add": "Add",
  "GenericAdminList_Footer_View": "View",
  "GenericAdminList_Footer_Change": "Change",
  "GenericAdminList_Footer_Delete": "Delete",
  "GenericAdminList_Footer_Selected": "{} Selected",
  "GenericAdminList_Footer_NoRows": "Nothing to see here...",
  "NAME": "GenericAdminListLanguage"
}